import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocalCurrency } from '../hooks/useLocalCurrency';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const {
    symbol,
    localPrice,
    localPriceStrikethrough,
    checkoutUrl
  } = useLocalCurrency();
  useEffect(() => {
    const purchaseSection = document.getElementById('purchase');
    if (!purchaseSection) return;
    const observer = new IntersectionObserver(([entry]) => {
      setIsVisible(entry.isIntersecting);
    }, {
      threshold: 0.1
    });
    observer.observe(purchaseSection);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-29">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} transition={{
      type: 'spring',
      damping: 25
    }} className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-slate-950 border-t border-slate-800 p-4 shadow-2xl" data-id="element-30">
          <div className="flex items-center justify-between gap-4" data-id="element-31">
            <div className="flex items-center gap-2" data-id="element-32">
              <span className="text-slate-500 line-through text-sm" data-id="element-33">
                {symbol}
                {localPriceStrikethrough}
              </span>
              <span className="text-white font-black text-xl" data-id="element-34">
                {symbol}
                {localPrice}
              </span>
            </div>
            <a href={checkoutUrl} className="flex-1 max-w-[200px] bg-orange-500 hover:bg-orange-400 text-white font-bold py-3 px-4 rounded-full text-center text-sm uppercase tracking-wide flex items-center justify-center gap-2 shadow-[0_4px_0_rgb(154,52,18)] active:shadow-none active:translate-y-[4px] transition-all" data-id="element-35">
              Comprar
              <ArrowRight className="w-4 h-4" data-id="element-36" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}